import React from "react";
export const FadeInType = {
  SHORT: "fade-in-section-short",
  LONG: "fade-in-section-long",
  FADEONLY: "fade-in-section-fade-only",
  TOLEFT: "fade-in-section-to-left",
};
export default function FadeInSection(props) {
  const [isVisible, setVisible] = React.useState(false);
  const domRef = React.useRef();
  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setVisible(entry.isIntersecting);
        if (entry.isIntersecting) {
          // this if statement is so it doesn't fade up again when you scroll back up, only meant to be pretty when it loads for the first time
          // if you really wanted you could add some additional props to make it so the fades persist
          observer.unobserve(domRef.current);
        }
      });
    });
    observer.observe(domRef.current);
  }, []);
  return (
    <div
      className={`${props.distance ?? "fade-in-section"} ${
        isVisible ? "is-visible" : ""
      }`}
      ref={domRef}
    >
      {props.children}
    </div>
  );
}
